// extracted by mini-css-extract-plugin
export default {"main":"MainBtn_main__aT-V-","disabled":"MainBtn_disabled__JWJCN"};